/* Фильтры «Финансов» одной строкой: раздел, бизнес и период.
   Нативные select и input[type=date] — на телефоне это привычные колёса выбора,
   а не самодельные списки, которые пришлось бы чинить под каждую платформу. */

import React, { useRef, useState } from "react";

import { Ion } from "./icons.jsx";

const shell =
  "relative shrink-0 inline-flex items-center rounded-full ps-3.5 pe-7 h-8 active:opacity-70";

const shellStyle = { background: "var(--tg-section-bg)" };
const textCls = "appearance-none bg-transparent outline-none text-[13px] font-semibold";

/* Нативный select всегда занимает ширину самого длинного варианта, поэтому
   ширину задаёт видимая подпись, а сам select лежит поверх прозрачным. */
export function FilterSelect({ value, onChange, options, ariaLabel }) {
  const current = options.find((o) => String(o.id) === String(value));
  return (
    <span className={shell} style={shellStyle}>
      <span
        className="text-[13px] font-semibold whitespace-nowrap"
        style={{ color: "var(--tg-text)" }}
      >
        {current?.label ?? ""}
      </span>
      <select
        className="absolute inset-0 w-full h-full opacity-0"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
      >
        {options.map((o) => (
          <option key={o.id} value={o.id}>{o.label}</option>
        ))}
      </select>
      <Ion.chevronDown
        size={12}
        className="absolute right-2.5 pointer-events-none"
        style={{ color: "var(--tg-hint)" }}
      />
    </span>
  );
}

/** ДД.ММ, а год — только если период выходит за пределы текущего года */
const short = (iso, withYear) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return withYear ? `${d}.${m}.${y.slice(2)}` : `${d}.${m}`;
};

/** Период одной кнопкой: тап раскрывает два поля с датами */
export function FilterPeriod({ from, to, thisYear, onChange }) {
  const btn = useRef(null);
  const [box, setBox] = useState(null);
  const open = !!box;
  const withYear = ![from, to].every((v) => !v || v.slice(0, 4) === String(thisYear));

  /* Строка фильтров прокручивается вбок и обрезает всё, что из неё торчит,
     поэтому панель рисуем fixed по координатам самой кнопки. */
  const toggle = () => {
    if (open) return setBox(null);
    const r = btn.current.getBoundingClientRect();
    setBox({ top: r.bottom + 8 });
  };

  return (
    <>
      <button
        ref={btn}
        type="button"
        className={`${shell} pe-7`}
        style={shellStyle}
        onClick={toggle}
        aria-label="Период"
      >
        <span className="num text-[13px] font-semibold whitespace-nowrap" style={{ color: "var(--tg-text)" }}>
          {short(from, withYear)} — {short(to, withYear)}
        </span>
        <Ion.chevronDown
          size={12}
          className="absolute right-2.5 pointer-events-none"
          style={{ color: "var(--tg-hint)", transform: open ? "rotate(180deg)" : "none", transition: "transform .2s" }}
        />
      </button>

      {open ? (
        <>
          {/* Клик мимо панели закрывает её */}
          <div className="fixed inset-0 z-30" onClick={() => setBox(null)} />
          <div
            className="rise fixed left-4 right-4 z-40 flex items-center gap-2 rounded-2xl px-3 py-2.5"
            style={{ top: box.top, background: "var(--tg-section-bg)", boxShadow: "0 8px 24px rgba(0,0,0,0.18)" }}
          >
          <input
            type="date"
            className="num flex-1 min-w-0 bg-transparent outline-none text-[15px]"
            style={{ color: "var(--tg-text)" }}
            value={from}
            onChange={(e) => onChange({ from: e.target.value, to })}
            aria-label="Начало периода"
          />
          <span style={{ color: "var(--tg-hint)" }}>—</span>
          <input
            type="date"
            className="num flex-1 min-w-0 bg-transparent outline-none text-[15px]"
            style={{ color: "var(--tg-text)" }}
            value={to}
            onChange={(e) => onChange({ from, to: e.target.value })}
            aria-label="Конец периода"
          />
            <button
              type="button"
              onClick={() => setBox(null)}
              className="shrink-0 text-[13px] font-semibold active:opacity-60"
              style={{ color: "var(--tg-link)" }}
            >
              Готово
            </button>
          </div>
        </>
      ) : null}
    </>
  );
}
